<template>
  <div class="page_underGuarantee">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div>
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
            <el-form-item label="方案名称" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="供应商" size="small">
              <el-select v-model="listQuery.name" placeholder="" size="small" clearable filterable>
                <el-option v-for="(item,index) in planList" :key="index" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保单号" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>商保管理</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>申报端</el-breadcrumb-item> -->
          <el-breadcrumb-item>失效人员</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="background-color: #fff;">
        <tabs :name="name" @changeType="changeType"></tabs>
      </div>
      <div class="ftabs">
        <div style="margin-bottom: 10px;" class="flex">
          <el-button type="primary" size="small" v-preventReClick @click="expList()">&nbsp;全部导出</el-button>
          <!-- <el-button type="warning" size="small" @click="showBatchDeclare" v-if="type == 'underGuarantee'">&nbsp;批量报减</el-button> -->
        </div>

        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="BatchNum" label="投保批次号" width="90px" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <!-- <el-table-column prop="Name" label="服务商" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column> -->
          <el-table-column prop="Projectid" label="项目ID" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ProjectName" label="项目名称" :show-overflow-tooltip="true" align="center" width="100">
          </el-table-column>
          <el-table-column prop="Service" label="部门/客服" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="InsuredName" label="姓名" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="InsuredCardId" label="证件号码" :show-overflow-tooltip="true" align="center" width="140">
          </el-table-column>
          <el-table-column prop="InsuredPhone" label="手机号码" :show-overflow-tooltip="true" align="center" width="110">
          </el-table-column>
          <el-table-column prop="JobName" label="岗位" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="InsuranceName" label="险种名称" :show-overflow-tooltip="true" align="center" width="130">
          </el-table-column>
          <el-table-column prop="Price" label="保费价格" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PriceUnit" label="价格单位" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="医保类型" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CreateTime" label="申请日期" :show-overflow-tooltip="true" align="center" width="150">
            <template slot-scope={row}>{{ row.CreateTime ? row.CreateTime.replace('T',' ') : ''}}</template>
          </el-table-column>
          <el-table-column prop="CoverStartTime" label="保障开始" :show-overflow-tooltip="true" align="center" width="110">
            <template slot-scope={row}>{{ row.CoverStartTime ? row.CoverStartTime.split('T')[0] : ''}}</template>
          </el-table-column>
          <el-table-column prop="CoverEndTime" label="保障结束" :show-overflow-tooltip="true" align="center" width="110">
            <template slot-scope={row}>{{ row.CoverEndTime ? row.CoverEndTime.split('T')[0] : ''}}</template>
          </el-table-column>
          <el-table-column prop="Status" label="人员状态" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="Name" label="报减批次号" :show-overflow-tooltip="true" align="center" width="90">
          </el-table-column> -->
          <!-- <el-table-column prop="Name" label="操作" align="center" fixed="right" min-width="120px" v-if="type=='underGuarantee'">
            <template slot-scope={row}>
              <div class="eleTabBtn">
                <el-button type="text" v-preventReClick @click="showDeclare = true">报减</el-button>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import tabs from "./components/declareTabs.vue";
  export default {
    components: {
      tabs
    },
    data() {
      return {
        name: '/lapse',
        listQuery: {
          pageNum: 1,
          pageSize: 10
        },
        totalCount:0,
        roletype: localStorage.loginRoletype,
        showDropScreen: -1,
        planList: ['方案1', '方案2'], //服务商方案列表
        loading: false,
        tableData: [],
        showDeclare: false, //增/减员弹窗
        showBatchDeclare: false, //批量增减员弹窗
      }
    },
    created() {
    },
    methods: {
      checkPermission,
      searchHandle() {},
      handleClick() {},
      //切换增/减员状态
      changeType(val) {
        this.type = val;
      },
      //下载模板
      downImportTemp() {},
      //文件读取
      async importf() {
        const fileInput = this.$refs.upload;
        FUN.fileToBase64(fileInput.files[0]).then(res => {
          if (res) {
            console.log(res)
          } else {
            this.$message("上传Excel失败!");
            this.isUploadSuccess = false;
            this.$refs['upload'].value = null;
          }
        })
      },
      //获取在保人员
      // getInsuredPersonsList() {
      //   xz.getInsuredPersonsList(this.listQuery, this.roletype).then(res => {
      //     if (res.status == 'ok') {
      //       this.tableData = res.data.List;
      //       this.totalCount = res.data.totalCount;
      //       this.loading = false;
      //     } else {
      //       this.loading = false;
      //       this.$message.error('系统出错！');
      //       this.tableData = [];
      //     }
      //   })
      // },
      currentChange2(val) {
        this.listQuery2.pageNum = Number(val);
        this.getInsuredPersonsList();
      },
      handleSizeChange2(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery2.pageNum = 1;
        this.listQuery2.pageSize = val;
        this.getInsuredPersonsList();
      },
      //导出列表
      expList() {
        this.loading = true;
        let data = {
          IsExport: '1',
          pageNum: 1,
          pageSize: 10000
        }
        xz.getInsuredPersonsList(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a");
            aLink.download = '在保人员.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.loading = false;
          } else {
            this.$message.error('导出失败')
            this.loading = false;
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  .file-box {
    position: relative;
    display: flex;
    align-items: center;
  }

  .file-box input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
  }

  .file-btn {
    display: inline-block;
    width: 54px;
    height: 28px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center !important;
    line-height: 28px;
    color: #333333;
    margin-left: 8px;
    margin-top: 4px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
<style>
  .page_underGuarantee .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_underGuarantee .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_underGuarantee .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_underGuarantee .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_underGuarantee .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_underGuarantee .declareForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_underGuarantee .declareForm .el-form-item__error {
    top: 34px;
  }
</style>